import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { IIssueProviderService, IIssueTransactionView, ISSUE_PROVIDER_SERVICE } from '../../../interfaces';
import { Issue, IssueItem, TransformIssueItemTask } from '../../../classes';
import { Step, STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';
import { combineLatest, of, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ContractService } from 'src/app/lib/contract/services/contract.service';
import { Contract } from 'src/app/lib/contract/classes';
import { showAnimation } from 'src/animations';
import { IssueService } from '../../../services/issue.service';

@Component({
  selector: 'app-book-issue-items-form',
  templateUrl: './book-issue-items-form.component.html',
  styleUrls: ['./book-issue-items-form.component.css'],
  animations: [ showAnimation ]
})
export class BookIssueItemsFormComponent implements IIssueTransactionView, OnDestroy, OnInit {

  items: IssueItem[] = [];
  contracts: Contract[] = [];

  mappingReadOnly: { [key: number]: number } = {};

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject('step') private _step: Step,
    @Inject(ISSUE_PROVIDER_SERVICE) private _issueProviderService: IIssueProviderService,
    @Inject(STEP_FORM_GROUP) public formGroup: FormGroup,
    private _contractService: ContractService,
    private _issueService: IssueService,
    private _formBuilder: FormBuilder
  ) { }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this.tasksControl.valueChanges.subscribe((value: TransformIssueItemTask[]) => this._step.visibleInConclusion = value.length > 0? true: false),
      this._issueProviderService.issue$.pipe(switchMap((issue: Issue) => combineLatest([this._contractService.getCustomerContracts(issue.issuecustomer), of(issue), this._issueService.getIssueItems(issue.issueid)]))).subscribe(([contracts, issue, items]) => {
        this.contracts = contracts;
        this.setItems(items);
      })
    ])
  }

  setMapping(item: IssueItem, contract: Contract) {
    let index = this
      .tasksControl
      .controls
      .findIndex(x => (x.value as TransformIssueItemTask).item === item.itemid);

    if (this.mappingReadOnly[item.itemid]) {
      if (this.mappingReadOnly[item.itemid] === contract.contractid) {
        this.mappingReadOnly[item.itemid] = null;
        if (index > -1) this.tasksControl.removeAt(index);
      }
      else {
        this.mappingReadOnly[item.itemid] = contract.contractid;
        if (index > -1) (this.tasksControl.controls[index] as FormGroup).controls['contract'].setValue(contract.contractid);
      }
    } else {
      this.mappingReadOnly[item.itemid] = contract.contractid;
      this.tasksControl.push(this._formBuilder.group({
        item: item.itemid,
        contract: contract.contractid
      }));
    }
  }

  setItems(items: IssueItem[]) {
    this.items = [];
    if(!Array.isArray(items)) return;
    this.items = items.filter(x => !x.itemcontract);
    for (let item of this.items) {
      let task = this.tasksControl.controls.find(x => (x.value as TransformIssueItemTask).item === item.itemid);
      this.mappingReadOnly[item.itemid] = task ? (task.value as TransformIssueItemTask).contract : null;
    }
  }

  get tasksControl(): FormArray {
    return this.formGroup.controls['tasks'] as FormArray;
  }

}
